// tokenUtils.js
import axios from "axios";

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");

  if (!refreshToken) throw new Error("No refresh token");

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/token/refresh/`, // Use full URL if axios has no baseURL
      {
        refresh: refreshToken,
      },
    );

    const newAccessToken = response.data.access;
    localStorage.setItem("accessToken", newAccessToken);

    const data = response?.data;

    const isInvalidFromBody =
      data?.status === "failed" ||
      data?.response_code === 401 

    if (isInvalidFromBody) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      window.location.replace("/mainLogin");
      return null;
    }
    return newAccessToken;
  } catch (err) {
    const status = err?.response?.status;
    const data = err?.response?.data;

    const isInvalidRefresh =
      status === 401 &&
      (data?.status === "failed" ||
        data?.message?.toLowerCase()?.includes("invalid") ||
        data?.message?.toLowerCase()?.includes("expired"));

    if (isInvalidRefresh) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");

      // ✅ redirect to main login
      window.location.replace("/mainLogin");
      return;
    }

    throw err;
  }
};
